export default __webpack_public_path__ + "static/media/sc27.805b6e03.jpg";